import { useCarousel } from '../CarouselProvider'

export const useButtonBack = () => {
  const {
    currentImage,
    setCurrentImageProgrammatically,
    totalImages,
    isFinite,
  } = useCarousel()

  const handleClick = () => {
    if (currentImage > 0) {
      setCurrentImageProgrammatically(currentImage - 1)
    } else if (!isFinite) {
      setCurrentImageProgrammatically(totalImages - 1)
    }
  }

  const isDisabled = totalImages <= 1 || (isFinite && currentImage === 0)

  return { onClick: handleClick, disabled: isDisabled }
}

export const useButtonNext = () => {
  const {
    currentImage,
    setCurrentImageProgrammatically,
    totalImages,
    isFinite,
  } = useCarousel()

  const handleClick = () => {
    if (currentImage < totalImages - 1) {
      setCurrentImageProgrammatically(currentImage + 1)
    } else if (!isFinite) {
      setCurrentImageProgrammatically(0)
    }
  }

  const isDisabled =
    totalImages <= 1 || (isFinite && currentImage === totalImages - 1)

  return { onClick: handleClick, disabled: isDisabled }
}
